import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function usePageTitle(pageNameKey: string) {
  const { t } = useTranslation();
  useEffect(() => {
    const pageName = t(pageNameKey, { defaultValue: pageNameKey });
    document.title = `${pageName} · Infoscend Claims — Mondelez Indonesia Demo`;
    return () => {
      document.title = 'Infoscend Claims — Mondelez Indonesia Demo';
    };
  }, [pageNameKey, t]);
}
